export class FormFieldsProvider {
  constructor(fdFormTypes) {
    'ngInject';

    this.types = fdFormTypes;
    this.typeOptions = {};
  }

  getTypes() {
    return this.types;
  }

  getTypeOptions(type) {
    return this.typeOptions[type] || {};
  }

  setTypeOptions(type, options) {
    if (!this.typeOptions[type]) {
      this.typeOptions[type] = {};
    }
    angular.extend(this.typeOptions[type], options);
  }

  $get() {
    'ngInject';
    const { types, typeOptions, getTypeOptions, setTypeModifier } = this;

    return {
      types,
      typeOptions,
      getTypeOptions,
      setTypeModifier
    }
  }
}
